<template>
    <div class="ex-page">
        <AnimatedContent :distance="24" :duration="0.7">
            <section class="ex-card">
                <h2>{{ $t('exchange.title') }}</h2>

                <div class="ex-box">
                    <div class="ex-box__head">
                        <span>{{ $t('exchange.send') }}</span>
                        <div class="ex-box__balance">
                            <img src="@/assets/img/exchange/icon-wallet-sm.svg" alt="">
                            <em>{{ $t('exchange.balance') }}: {{ Number(sendBalance).toFixed(2) }}</em>
                            <button type="button" @click="setMax">{{ $t('exchange.max') }}</button>
                        </div>
                    </div>
                    <div class="ex-box__body">
                        <div class="ex-token-wrap" @click.stop>
                            <button class="ex-token" type="button" @click="toggleMenu('send')">
                                <img :src="tokenIcon(sendToken)" alt="">
                                <span>{{ sendToken }}</span>
                                <i class="ex-token__chev" :class="{ open: tokenMenu === 'send' }"></i>
                            </button>
                            <div v-show="tokenMenu === 'send'" class="ex-token-menu">
                                <button
                                    v-for="t in tokens"
                                    :key="'send-' + t"
                                    type="button"
                                    :class="{ active: sendToken === t }"
                                    @click="selectSendToken(t)"
                                >
                                    <img :src="tokenIcon(t)" alt="">
                                    <span>{{ t }}</span>
                                </button>
                            </div>
                        </div>
                        <input
                            v-model="sendAmount"
                            class="ex-box__amount"
                            type="text"
                            inputmode="decimal"
                            placeholder="0"
                        >
                    </div>
                </div>

                <button class="ex-swap" type="button" @click="swapTokens">
                    <img src="@/assets/img/exchange/icon-swap.svg" alt="">
                </button>

                <div class="ex-box">
                    <div class="ex-box__head">
                        <span>{{ $t('exchange.receive') }}</span>
                        <div class="ex-box__balance">
                            <img src="@/assets/img/exchange/icon-wallet-sm.svg" alt="">
                            <em>{{ $t('exchange.balance') }}: {{ Number(receiveBalance).toFixed(2) }}</em>
                        </div>
                    </div>
                    <div class="ex-box__body">
                        <div class="ex-token-wrap" @click.stop>
                            <button class="ex-token" type="button" @click="toggleMenu('receive')">
                                <img :src="tokenIcon(receiveToken)" alt="">
                                <span>{{ receiveToken }}</span>
                                <i class="ex-token__chev" :class="{ open: tokenMenu === 'receive' }"></i>
                            </button>
                            <div v-show="tokenMenu === 'receive'" class="ex-token-menu">
                                <button
                                    v-for="t in tokens"
                                    :key="'recv-' + t"
                                    type="button"
                                    :class="{ active: receiveToken === t }"
                                    @click="selectReceiveToken(t)"
                                >
                                    <img :src="tokenIcon(t)" alt="">
                                    <span>{{ t }}</span>
                                </button>
                            </div>
                        </div>
                        <strong class="ex-box__amount ex-box__amount--out">{{ receiveAmount }}</strong>
                    </div>
                </div>

                <div class="ex-price">
                    <div class="ex-price__left">
                        <img src="@/assets/img/exchange/icon-price.png" alt="">
                        <span>{{ $t('exchange.currentPrice') }}</span>
                    </div>
                    <b>1 DOL = {{Number(dolPrice).toFixed(4)}} U </b>
                </div>

                <StarBorder as="div" customClass="star-cta star-cta--submit" color="#FFE566" speed="4s" :thickness="0">
                    <button class="ex-btn" type="button" @click="doExchange()">{{ $t('exchange.submit') }}</button>
                </StarBorder>
            </section>
        </AnimatedContent>

        <FadeContent :blur="false" :delay="60" :duration="800">
            <section class="ex-card ex-record">
                <h2 class="ex-record__title"><span>{{ $t('exchange.records') }}</span></h2>
                <FadeContent
                    v-for="(item, index) in list"
                    :key="item.ID"
                    :delay="70 * index"
                    :duration="500"
                >
                    <div class="ex-item" :class="{ 'is-split': index > 0 }">
                        <div class="ex-item__top">
                            <p>
                                <img src="@/assets/img/mining/icon-clock.png" alt="">
                                <span>{{ item.AddTime.replace('T',' ').slice(0,19) }}</span>
                            </p>
                            <em class="ok">
                                {{$t('exchange.success') }}
                            </em>
                        </div>
                        <div class="ex-item__nums">
                            <div>
                                <label>{{ $t('exchange.send') }} <i>({{ item.buysell?'DOL':'USDT' }})</i></label>
                                <strong>
                                    {{Number(item.sendAmount).toFixed(2)}}
                                </strong>
                            </div>
                            <div>
                                <label>{{  $t('exchange.receive') }} <i>({{ item.buysell?'USDT':'DOL' }})</i></label>
                                <strong>
                                    {{Number(item.addAmount).toFixed(2)}}
                                </strong>
                            </div>
                            <div>
                                <label>{{ $t('exchange.price') }} (USDT)</label>
                                <strong>
                                    {{Number(item.dolPrice).toFixed(4)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </FadeContent>
            </section>
        </FadeContent>
    </div>
</template>

<script>
import AnimatedContent from '@/components/AnimatedContent/AnimatedContent.vue';
import FadeContent from '@/components/FadeContent/FadeContent.vue';
import NumberScroll from '@/components/NumberScroll.vue';
import StarBorder from '@/components/StarBorder/StarBorder.vue';

/** 设计稿：0.11 USDT → 0.3212 FOVO */
const USDT_TO_FOVO = 0.3212 / 0.11;


import axios from 'axios'
import contractaa from '../contract/index.js';


import Web3 from 'web3'
let web3
web3 = new Web3(window.ethereum);

export default {
    name: 'exchange-page',
    components: { AnimatedContent, FadeContent, NumberScroll, StarBorder },
    data() {
        return {
            sendToken: 'USDT',
            receiveToken: 'DOL',
            sendAmount: '',
            tokenMenu: '',
            tokens: ['USDT', 'DOL'],
            balances: { USDT: 0, DOL: 0 },
            records: [
                { id: 1, time: '2026-09-28 15:37:01', ok: true, send: 30, sendUnit: 'USDT', receive: 100, receiveUnit: 'T', sendKey: 'send', receiveKey: 'receive', price: 0.01 },
                { id: 2, time: '2026-09-28 15:37:01', ok: true, send: 30, sendUnit: 'USDT', receive: 100, receiveUnit: 'T', sendKey: 'send', receiveKey: 'receive', price: 0.01 },
                { id: 3, time: '2026-09-28 15:37:01', ok: true, send: 30, sendUnit: 'USDT', receive: 100, receiveUnit: 'T', sendKey: 'consume', receiveKey: 'obtain', price: 0.01 },
            ],
            dolPrice:0,
            list:[],
            minu:0,
            mindol:0,
        };
    },
    computed: {
        sendBalance() {
            return this.balances[this.sendToken] || 0;
        },
        receiveBalance() {
            return this.balances[this.receiveToken] || 0;
        },
        receiveAmount() {
            const n = parseFloat(this.sendAmount);
            if (!n || Number.isNaN(n)) return '0';
            if (this.sendToken === 'USDT') return (n / this.dolPrice).toFixed(4);
            return (n * this.dolPrice).toFixed(4);
        },

        recordsMapped() {
            return this.records.map((item) => ({
                ...item,
                sendLabel: this.$t(`exchange.${item.sendKey}`),
                receiveLabel: this.$t(`exchange.${item.receiveKey}`),
            }));
        },
    },
    mounted() {
        document.addEventListener('click', this.closeMenus);
        this.getInfo()
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeMenus);
    },
    methods: {
        tokenIcon(token) {
            return token === 'USDT'
                ? require('@/assets/img/mining/token-usdt.png')
                : require('@/assets/img/mining/token-fovo.png');
        },
        closeMenus() {
            this.tokenMenu = '';
        },
        toggleMenu(side) {
            this.tokenMenu = this.tokenMenu === side ? '' : side;
        },
        otherToken(token) {
            return this.tokens.find((t) => t !== token) || this.tokens[0];
        },
        selectSendToken(token) {
            this.sendToken = token;
            if (this.receiveToken === token) {
                this.receiveToken = this.otherToken(token);
            }
            this.tokenMenu = '';
        },
        selectReceiveToken(token) {
            this.receiveToken = token;
            if (this.sendToken === token) {
                this.sendToken = this.otherToken(token);
            }
            this.tokenMenu = '';
        },
        setMax() {
            this.sendAmount = String(this.sendBalance);
        },
        swapTokens() {
            this.tokenMenu = '';
            const st = this.sendToken;
            this.sendToken = this.receiveToken;
            this.receiveToken = st;
            //this.sendAmount = this.receiveAmount === '0' ? '' : this.receiveAmount;
            this.sendAmount = 0
        },
        async getInfo(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            let axiosResult = await axios.post(contractaa.APIURL+'?cmd=exchange','addr='+useraddr+'&page=1');
            if(axiosResult.status == 200){
                if(axiosResult.data.Status){
                    let _arr = axiosResult.data.Message.split('|')

                    that.balances.USDT = Number(_arr[1])
                    that.balances.DOL = Number(_arr[2])
                    that.dolPrice = Number(_arr[3])
                    that.minu = Number(_arr[4])
                    that.mindol = Number(_arr[5])
                    that.list = axiosResult.data.Data
                }
            }
        },
        //兑换按钮
        async doExchange(){
            let that = this
            let useraddr = this.$store.state.globalAddress

            if(that.sendToken == "USDT"){
                if(that.sendAmount < that.minu){
                    that.$toast.fail('最小兑换数量为：'+that.minu)
                    return
                }
                if(that.sendAmount > that.balances.USDT){
                    that.$toast.fail('余额不足')
                    return
                }

            }else if(that.sendToken == "DOL"){
                if(that.sendAmount < that.mindol){
                    that.$toast.fail('最小兑换数量为：'+that.mindol)
                    return
                }
                if(that.sendAmount > that.balances.DOL){
                    that.$toast.fail('余额不足')
                    return
                }

            }


            that.$store.commit('handleShow', true)
            let vstr="欢迎来到 OnOx 火牛宪章，DolphFi 生态首发 DApp 正式上线。"
            let vsign = await ethereum.request({method: "personal_sign",params: [vstr, useraddr]});

            let result = await axios.post(contractaa.APIURL+'?cmd=addex'+that.sendToken,"addr="+useraddr+"&singer="+vsign+"&amount="+that.sendAmount)
            if(result.data.Status){
                that.$store.commit('handleShow', false)  
                that.$toast.success(that.$t('layout.success'))

            }else{
                //that.$toast.fail(that.$t('layout.failed'))
                that.$toast.fail(result.data.Message)
                that.$store.commit('handleShow', false)  
            }
           
            that.getInfo()
        }
    }
};
</script>

<style lang="less" scoped>
.ex-page {
    padding: 12px 16px 0;
}

.ex-card {
    background: #FFFFFF;
    border-radius: 14px;
    padding: 15px;
    margin-bottom: 16px;

    > h2 {
        margin: 0 0 12px;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #101126;
    }
}

.ex-box {
    background: #FAFBFC;
    border: 1px solid #E3E3E3;
    border-radius: 10px;
    padding: 14px 15px 12px;
}

.ex-box__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    > span {
        font-size: 12px;
        line-height: 12px;
        color: #101126;
        opacity: 0.66;
    }
}

.ex-box__balance {
    display: flex;
    align-items: center;
    gap: 4px;

    img {
        width: 10px;
        height: 10px;
    }

    em {
        font-style: normal;
        font-size: 12px;
        line-height: 12px;
        color: #101126;
        opacity: 0.66;
    }

    button {
        margin-left: 6px;
        padding: 0 0 0 8px;
        border: 0;
        border-left: 1px solid #E3E3E3;
        background: none;
        font-size: 12px;
        line-height: 12px;
        color: #101126;
    }
}

.ex-box__body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.ex-token-wrap {
    position: relative;
    flex-shrink: 0;
}

.ex-token {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 28px;
    padding: 0 10px 0 6px;
    border-radius: 18px;
    border: 1px solid #E3E3E3;
    background: #FAFBFC;

    img {
        width: 16px;
        height: 16px;
        border-radius: 50%;
    }

    span {
        font-size: 12px;
        line-height: 16px;
        color: #101126;
    }
}

.ex-token__chev {
    width: 0;
    height: 0;
    border-left: 3.5px solid transparent;
    border-right: 3.5px solid transparent;
    border-top: 4px solid #101126;
    margin-left: 2px;
    transition: transform 0.2s;

    &.open {
        transform: rotate(180deg);
    }
}

.ex-token-menu {
    position: absolute;
    top: 34px;
    left: 0;
    z-index: 8;
    min-width: 112px;
    padding: 4px 0;
    background: #FFFFFF;
    border: 0.5px solid #E7E7E7;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(16, 17, 38, 0.12);

    button {
        width: 100%;
        height: 34px;
        padding: 0 12px;
        border: 0;
        background: transparent;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        color: #101126;

        img {
            width: 16px;
            height: 16px;
            border-radius: 50%;
        }

        &.active {
            background: rgba(252, 238, 153, 0.3);
        }
    }
}

.ex-box__amount {
    flex: 1;
    min-width: 0;
    border: 0;
    outline: none;
    background: transparent;
    text-align: right;
    font-family: 'D-DIN', 'DIN Alternate', sans-serif;
    font-weight: 700;
    font-size: 26px;
    line-height: 24px;
    color: #101126;

    &--out {
        opacity: 0.5;
        display: block;
    }
}

.ex-swap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    margin: -12px auto;
    padding: 0;
    border: 0;
    background: transparent;
    position: relative;
    z-index: 2;

    img {
        width: 38px;
        height: 38px;
    }
}

.ex-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0 10px;
    min-height: 40px;

    &__left {
        display: flex;
        align-items: center;
        gap: 8px;

        img {
            width: 18px;
            height: 18px;
        }

        span {
            font-size: 12px;
            line-height: 12px;
            color: #101126;
            opacity: 0.5;
        }
    }

    b {
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #101126;
    }
}

.ex-btn {
    width: 100%;
    height: 40px;
    border: 0;
    border-radius: 10px;
    background-image: linear-gradient(-85deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
    font-size: 14px;
    font-weight: 500;
    color: #101126;
}

::v-deep .star-cta--submit {
    display: block;
    width: 100%;
    margin-top: 0;
}

.ex-record {
    padding-bottom: 8px;

    &__title {
        margin: 0 !important;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #101126;
        border-bottom: 0.5px solid #E3E3E3;

        span {
            display: inline-block;
            padding-bottom: 8px;
            border-bottom: 3px solid #101126;
            margin-bottom: -1px;
        }
    }
}

.ex-item {
    padding: 16px 0;

    &.is-split {
        border-top: 0.5px solid #E3E3E3;
    }

    &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        p {
            display: flex;
            align-items: center;
            gap: 4px;
            margin: 0;
            font-size: 12px;
            line-height: 12px;
            color: #101126;
            opacity: 0.5;

            img {
                width: 10px;
                height: 10px;
            }
        }

        em {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 50px;
            height: 22px;
            padding: 0 10px;
            border-radius: 13px;
            font-style: normal;
            font-size: 13px;
            font-weight: 500;

            &.ok {
                background: #E5FAEC;
                color: #048C4D;
            }

            &.fail {
                background: #FDECEC;
                color: #D14343;
            }
        }
    }

    &__nums {
        display: flex;
        align-items: flex-start;

        > div {
            flex: 1;

            label {
                display: block;
                margin-bottom: 4px;
                font-size: 12px;
                line-height: 12px;
                color: #101126;
                opacity: 0.7;

                i {
                    font-style: normal;
                }
            }

            strong {
                display: block;
                font-family: 'D-DIN', 'DIN Alternate', sans-serif;
                font-weight: 500;
                font-size: 16px;
                line-height: 20px;
                color: #101126;
            }
        }
    }
}
</style>
